import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20with%20warm%20cream%20and%20beige%20tones%2C%20soft%20gradients%2C%20organic%20flowing%20shapes%2C%20modern%20art%20inspired%20design%2C%20clean%20elegant%20aesthetic%2C%20light%20airy%20atmosphere%2C%20subtle%20texture%20background%2C%20professional%20corporate%20feel%2C%20no%20text%20no%20people%20just%20abstract%20patterns&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="17c一起草国"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          探索<span className="text-accent-500">优质内容</span>
          <br />
          发现无限可能
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          17c一起草国致力于打造高品质内容生态，汇聚海量精选文章，
          覆盖热门推荐、深度解读、精品原创、教程指南等多个领域，为每一位求知者提供最佳阅读体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hot"
            className="px-8 py-3 bg-accent-500 text-background-50 rounded-md font-medium text-sm hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 text-white rounded-md font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}